<template>
  <div>
    <b-modal
      ref="orderMore"
      title="Order More"
      :ok-only="true"
      @ok="orderMoreClick"
      ok-title="Next"
      size="lg"
    >
      The records from the orders you selected will automatically be removed.<br />
      <b-form-group
        label="Would you like to suppress any other orders?"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-radio-group
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          @change="suppressionTypeChange($event)"
          name="some-radios"
        >
          <b-form-radio value="Yes">Yes</b-form-radio>
          <b-form-radio value="No">No</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <div v-if="selected === 'Yes'">
        <b-form-radio-group v-model="subType">
          <b-form-radio
            value="date"
            :data-test="`demo-suppression-box-date-order`"
            >Suppress by Date Range</b-form-radio
          >
          <b-form-radio
            value="item"
            :data-test="`demo-suppression-box-item-order`"
            >Suppress by Selected Orders</b-form-radio
          >
        </b-form-radio-group>
        <div v-if="subType === 'date'">
          Start Date
          <datepicker v-model="startDate"></datepicker>
          End Date
          <datepicker
            v-model="endDate"
            :disabled="endDateDisabled"
          ></datepicker>
        </div>
        <div v-if="subType === 'item'">
          <b-card>
            <p class="m-text-deep">Your Order List</p>
            <table class="table">
              <tr>
                <th>Order Date</th>
                <th>Order Code</th>
                <th>Order Name</th>
                <th>Quantity</th>
                <th>Action</th>
              </tr>
              <tr v-for="item in itemDatas" class="tr">
                <td class="td">
                  {{ item.OrderDate | formatDate("MM/DD/YYYY") }}
                </td>
                <td class="td">
                  {{ item.OrderCode || item.SuppressionDesc || "" }}
                </td>
                <td class="td">
                  {{ item.OrderDesc }}
                </td>
                <td class="td">
                  {{ item.TotalDesiredQty | numberFormat("", 0) }}
                </td>
                <td class="td">
                  <b-btn
                    @click="addItem(item)"
                    variant="sm"
                    v-show="
                      !item.added && item.OrderCode !== orderMoreData.OrderCode
                    "
                    :data-value="item.OrderCode || item.SuppressionDesc || ''"
                    >Add</b-btn
                  >
                </td>
              </tr>
            </table>

            <b-pagination
              size="sm"
              :total-rows="suppressionTotalCount"
              :per-page="12"
              v-model="page.PageNumber"
              @input="getSuppression"
            ></b-pagination>
          </b-card>
          <b-card style="margin-top: 16px">
            <p class="m-text-deep">Suppressed Orders</p>
            <table class="table">
              <tr>
                <th width="40%">Order Code</th>
                <th width="40%">Order Name</th>
                <th width="20%">Action</th>
              </tr>
              <tr v-for="item of suppressions" class="tr">
                <td class="td">{{ item.code }}</td>
                <td class="td">{{ item.name }}</td>
                <td class="td">
                  <b-btn
                    variant="sm"
                    @click="removeItem(item.code)"
                    v-show="item.code !== orderMoreData.OrderCode"
                    >Remove</b-btn
                  >
                </td>
              </tr>
            </table>
          </b-card>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="seeOrderDetail"
      scrollable
      title="Order Detail"
      :ok-only="true"
      size="lg"
    >
      <b-table-simple caption-top stacked>
        <b-tbody>
          <b-tr>
            <b-th> Order Information </b-th>
            <b-td stacked-heading="Order ID:">{{ detail.OrderCode }} </b-td>
            <b-td stacked-heading="Order Date:">{{ formatDate }} </b-td>
            <b-td stacked-heading="Qty Available:"
              >{{ detail.TotalAvailableQty | numberFormat("", 0) }}
            </b-td>
            <b-td stacked-heading="Qty Selected:"
              >{{ detail.TotalDesiredQty | numberFormat("", 0) }}
            </b-td>
            <b-td
              v-if="detail.GeographyCharge > 0"
              stacked-heading="Geograpyh Charge:"
              >{{ detail.GeographyCharge | numberFormat() }}
            </b-td>
            <b-td
              v-if="detail.ServiceCharge > 0"
              stacked-heading="Electronic Delivery Fee:"
              >{{ detail.ServiceCharge | numberFormat() }}
            </b-td>
            <b-td stacked-heading="Total Charge:"
              >{{ detail.TotalEstmCost | numberFormat() }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>List Details</b-th>
            <b-td stacked-heading="Type:">{{ detail.DataSourceDesc }} </b-td>
            <b-td stacked-heading="Usage:">{{ getListUsageName }} </b-td>
            <b-td
              v-if="
                detail.ListType !== 50 &&
                detail.ListType !== 200 &&
                detail.ListType !== 210
              "
              stacked-heading="Phone Option:"
              >{{ getPhoneOption }}
            </b-td>
            <b-td
              v-if="detail.ListType !== 50 && detail.DemoType != 1"
              stacked-heading="Target Audience:	"
              >All records in selected geography
            </b-td>
            <b-td
              v-if="detail.ListType !== 50 && detail.DemoType == 1"
              stacked-heading="Target Audience:	"
            >
              <template v-for="record in detail.OrderSelectedDemos">
                <u :key="record.AttributeName">
                  {{ record.AttributeName }}
                </u>
                <li
                  v-for="value in record.Values"
                  :key="value.AttributeValueName"
                >
                  {{ value.AttributeValueName }}
                </li>
              </template>
            </b-td>
            <b-td
              v-if="detail.ListType === 50"
              stacked-heading="Target Audience:	"
            >
              <templage v-if="detail.TargetOption != 0">
                <u>Targeting Options</u>
                <ul>
                  <li v-if="(detail.TargetOption & 1) >= 1">Include homes</li>
                  <li v-if="(detail.TargetOption & 2) >= 1">
                    Include apartments
                  </li>
                  <li v-if="(detail.TargetOption & 4) >= 1">
                    Include businesses
                  </li>
                </ul>
              </templage>
              <templage v-if="detail.RouteOption != 0">
                <u>Route Options</u>
                <ul>
                  <li v-if="(detail.RouteOption & 1) >= 1">
                    Include Carrier Routes
                  </li>
                  <li v-if="(detail.RouteOption & 2) >= 1">Include PO Boxes</li>
                  <li v-if="(detail.RouteOption & 4) >= 1">Rural Routes</li>
                </ul>
              </templage>
              <templage v-if="detail.ContactNameOption != 0">
                <u>Contact Names</u>
                <ul>
                  <li>Include Contact Names Where Available</li>
                </ul>
              </templage>
            </b-td>
            <b-td
              v-if="
                this.detail.AdditionalOutputColumns != null &&
                this.detail.AdditionalOutputColumns != ''
              "
              stacked-heading="Additional Output Columns:	"
            >
              {{ getAdditionalOutputColumns }}
            </b-td>
          </b-tr>
          <b-tr v-if="detail.Chose4Info">
            <b-th>Mobile Package Information</b-th>
            <b-td stacked-heading="Package Option:">{{
              detail.MobilePackageName
            }}</b-td>
            <b-td stacked-heading="View Count:">{{
              detail.MobilePackageViewCount | numberFormat("", 0)
            }}</b-td>
          </b-tr>
          <b-tr v-if="isSuppression">
            <b-th>Suppression</b-th>
            <b-td
              v-if="
                detail.OrderSuppressions && detail.OrderSuppressions.length > 0
              "
              stacked-heading="Order Suppression:"
            >
              <span
                v-for="s in detail.OrderSuppressions"
                :key="s.SuppressedOrderCode"
                >{{ s.SuppressedOrderCode }},&nbsp;</span
              >
            </b-td>
            <b-td
              v-if="
                detail.CustomSuppressions &&
                detail.CustomSuppressions.length > 0
              "
              stacked-heading="Order Suppression:"
            >
              <span v-for="s in detail.CustomSuppressions" :key="s.FileName"
                >{{ s.FileName }},&nbsp;</span
              >
            </b-td>
            <b-td
              v-if="
                detail.SaveCountSuppressions &&
                detail.SaveCountSuppressions.length > 0
              "
              stacked-heading="Order Suppression:"
            >
              <span
                v-for="s in detail.SaveCountSuppressions"
                :key="s.SuppressedCountCode"
                >{{ s.SuppressedCountCode }},&nbsp;</span
              >
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>Geography Details</b-th>
            <b-td colspan="2">
              <b-table-simple>
                <b-tr>
                  <b-th>
                    {{ getGeoTypeName }}
                  </b-th>
                  <b-th>Quantity Selected </b-th>
                </b-tr>
                <template
                  v-if="
                    detail.GeoType != 7 &&
                    detail.GeoType != 12 &&
                    detail != 14 &&
                    detail != 15 &&
                    detail != 16 &&
                    detail != 17
                  "
                >
                  <templage
                    v-if="detail.ListType === 110 || detail.ListType === 120"
                  >
                    <b-tr>
                      <td>{{ getGeoTypeName }}</td>
                      <td>
                        {{ detail.TotalDesiredQty | numberFormat() }}
                      </td>
                    </b-tr>
                  </templage>
                  <template v-else>
                    <b-tr v-for="geo in detail.OrderGeos" :key="geo.GeoKeyCode">
                      <td>{{ geo.GeoKeyDesc }}</td>
                      <td>
                        {{ geo.DesiredQty | numberFormat("", 0) }}
                      </td>
                    </b-tr>
                  </template>
                </template>
                <template v-else>
                  <b-tr
                    v-for="geo in detail.SearchAddresses"
                    :key="geo.AddressName"
                  >
                    <td>{{ geo.AddressName }}</td>
                    <td>
                      {{ geo.TotalDesiredQty | numberFormat("", 0) }}
                    </td>
                  </b-tr>
                </template>
              </b-table-simple>
            </b-td>
          </b-tr>
          <b-tr
            v-if="
              detail.Status >= 40 &&
              detail.PaymentMethod === 1 &&
              detail.OrderPaymentInformation != null
            "
          >
            <b-th>Payment Information</b-th>
            <b-td stacked-heading="Card Type:">{{ cardTypeName }}</b-td>
            <b-td stacked-heading="Card Number: ">{{ formateCardNumber }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-modal>
    <b-row class="justify-content-md-center">
      <b-col xl="6" lg="6" md="6" sm="6" class="left-title"
        ><b-input-group class="mb-2">
          <b-input-group-prepend is-text>
            <icon name="search" />
          </b-input-group-prepend>
          <b-form-input
            class="search-text"
            v-model="searchKey"
            @input="searchChange"
            placeholder="Search for order ID, name to filter"
            aria-label="Text input with checkbox"
          ></b-form-input> </b-input-group
      ></b-col>
      <b-col xl="6" lg="6" md="6" sm="6" class="right-title">
        <b-form-select
          v-model="accountId"
          @change="leadPageChange"
          v-if="roleName === 'Reseller'"
          class="account-select"
        >
          <option value="0">ALL Accounts</option>
          <option v-for="item in accountList" :value="item.AccountId">
            {{ item.AccountDesc }}
          </option>
        </b-form-select>
        <b-link :href="exportExcel" target="blank" class="btn"
          >Export All</b-link
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table striped hover :fields="leadsFields" :items="LeadData">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(Account)="data">
            <span>{{
              roleName === "Power User"
                ? data.item.UserName
                : roleName === "Reseller"
                ? data.item.AccountName
                : ""
            }}</span>
          </template>
          <template #cell(Action)="data">
            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template #button-content>
                <icon name="ellipsis-v" />
              </template>
              <b-dropdown-item href="#" @click="showDetail(data)"
                >View</b-dropdown-item
              >
              <b-dropdown-item
                v-if="
                  data.item.Status === 75 &&
                  data.item.OnlineOrder &&
                  data.item.OrderType == 10
                "
                href="#"
                @click="orderMore(data)"
                >Order More</b-dropdown-item
              >
              <b-dropdown-item
                :href="fileLink + '?id=' + data.item.OrderCode + '&type=1'"
                v-if="
                  data.item.Status === 75 &&
                  data.item.OnlineOrder &&
                  data.item.ListType != 270
                "
                >Down Excel File</b-dropdown-item
              >
            </b-dropdown></template
          >
        </b-table>
        <b-row>
          <b-col md="3" lg="4" xl="4" sm="3" class="pageinfo">
            1-{{
              totalLeadDataCount % leadPageSize === 0
                ? totalLeadDataCount % leadPageSize
                : parseInt(totalLeadDataCount / leadPageSize) + 1
            }}
            of
            {{ totalLeadDataCount }}
          </b-col>
          <b-col>
            <b-pagination
              v-model="LeadDataCurrentPage"
              page-class="page-class"
              :total-rows="totalLeadDataCount"
              @change="leadPageChange"
              prev-text="＜PREVIOUS"
              next-text="NEXT＞"
              first-text="First"
              last-text="Last"
              align="left"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import notificaton from "@/components/common/notification";
import MBase from "@/components/layouts/MBase";
import MMaOrderHistory from "@/components/orderHistory/MMaOrderHistory";
import utils from "@/assets/utils";
import ListUsage from "@/config/ListUsage";
import PhoneOptions from "@/config/PhoneOptions";
import geoType from "@/config/geoType";
import paymentCardType from "@/config/paymentCardType";
import Datepicker from "vuejs-datepicker";
import _ from "lodash";

export default {
  components: {
    MBase,
    MMaOrderHistory,
    Datepicker,
  },
  data() {
    return {
      itemDatas: [],
      page: {
        PageNumber: 1,
        SortBy: "OrderDate",
        FetchTotalRecordCount: true,
        PageSize: 12,
        SortDescending: true,
        start: 0,
        TotalRecordCount: 0,
      },
      suppressionTotalCount: 9999,
      suppressions: [],
      subType: "item",
      selected: "No",
      accountId: "0",
      searchKey: "",
      tabType: -1,
      detail: {},
      orderMoreData: {},
      leadsFields: [
        {
          label: "Date",
          key: "OrderDate",
          formatter: (value) => {
            return utils.dateFormat(value, "MM/DD/YYYY");
          },
        },
        { label: "Order ID", key: "OrderCode" },
        { label: "Order Name", key: "OrderDesc" },
        { label: "Type", key: "DataSourceDesc" },
        {
          label: "Quantity",
          key: "TotalDesiredQty",
          formatter: (value) => {
            return utils.numberFormat(value, "", 0);
          },
        },
        {
          label: "Price",
          key: "TotalEstmCost",
          formatter: (value) => {
            return utils.numberFormat(value);
          },
        },
        { label: "Account", key: "Account" },
        { label: "Action", key: "Action" },
      ],
      LeadData: [],
      totalLeadDataCount: 0,
      leadPageSize: 18,
      LeadDataCurrentPage: 1,
      isOrderBusy: true,
      AdditionalOutputColumns: [],
    };
  },
  computed: {
    startDate: {
      get() {
        if (this.subType !== "date") {
          return null;
        }
        let date = null;
        if (!date) {
          date = new Date(new Date() - 7 * 86400000);
          this.orderMoreData.SuppressionStartDate = date;
        }
        return date;
      },
      set(val) {
        this.orderMoreData.SuppressionStartDate = val;
      },
    },
    endDate: {
      get() {
        if (this.subType !== "date") {
          return null;
        }
        let date = null;
        if (!date) {
          date = new Date();
          this.orderMoreData.SuppressionEndDate = date;
        }
        return date;
      },
      set(val) {
        this.orderMoreData.SuppressionEndDate = val;
      },
    },
    endDateDisabled() {
      return {
        from: new Date(),
        to: this.startDate,
      };
    },
    rootPath() {
      return utils.getRootPath();
    },
    fileLink() {
      return this.$store.getters["config/getOrderFile"];
    },
    accountList() {
      return this.$store.getters["user/accountList"];
    },
    roleName() {
      return this.$store.state.site.User_RoleName;
    },
    formatDate() {
      if (this.detail.OrderDate) {
        return utils.dateFormat(this.detail.OrderDate);
      }
    },
    getListUsageName() {
      if (this.detail.ListUsage) {
        let item = _.filter(ListUsage, (t) => {
          return t.Code === this.detail.ListUsage;
        });
        if (item.length > 0) {
          return item[0].DisplayName;
        } else {
          return "";
        }
      }
    },
    getPhoneOption() {
      if (this.detail.PhoneOption) {
        let option = this.detail.PhoneOption == 0 ? 1 : this.detail.PhoneOption;
        let item = _.filter(PhoneOptions, (t) => {
          return t.Code === this.detail.PhoneOption;
        });
        if (item.length > 0) {
          return item[0].DisplayName;
        } else {
          return "";
        }
      }
    },
    getAdditionalOutputColumns() {
      if (
        this.detail.AdditionalOutputColumns != null &&
        this.detail.AdditionalOutputColumns != ""
      ) {
        var cols = columns.split(",");
        if (cols) {
          var displayCols = "";
          for (var i = 0; i <= cols.length - 1; i++) {
            for (var j = 0; j <= this.AdditionalOutputColumns.length - 1; j++) {
              if (cols[i] == this.AdditionalOutputColumns[j].ColumnName) {
                if (i == cols.length - 1)
                  displayCols += this.AdditionalOutputColumns[j].ColumnDesc;
                else {
                  displayCols +=
                    this.AdditionalOutputColumns[j].ColumnDesc + ", ";
                }
                break;
              }
            }
          }
          return displayCols;
        } else {
          return "";
        }
      }
    },
    isSuppression() {
      return (
        (this.detail.OrderSuppressions != undefined &&
          this.detail.OrderSuppressions.length > 0) ||
        (this.detail.CustomSuppressions != undefined &&
          this.detail.CustomSuppressions.length > 0) ||
        (this.detail.SaveCountSuppressions != undefined &&
          this.detail.SaveCountSuppressions.length > 0)
      );
    },
    getGeoTypeName() {
      if (this.detail.GeoType) {
        let types = Object.values(geoType);
        let item = _.filter(types, (t) => {
          return t.code === this.detail.GeoType;
        });
        if (item.length > 0) {
          return item[0].title;
        } else {
          return "";
        }
      }
      return "";
    },
    cardTypeName() {
      if (this.detail.OrderPaymentInformation.CardType) {
        let item = _.filter(paymentCardType, (t) => {
          return t.value === this.detail.OrderPaymentInformation.CardType;
        });
        if (item.length > 0) {
          return item[0].text;
        } else {
          return "";
        }
      }
    },
    formateCardNumber() {
      if (this.detail.OrderPaymentInformation.Number) {
        return utils.formatCreditCard(
          this.detail.OrderPaymentInformation.Number
        );
      }
    },
    exportExcel() {
      return `${this.rootPath}RPT/DownReportFile.aspx?orderType=-1&accountId=${this.accountId}&searchKey=${this.searchKey}`;
    },
  },
  created() {
    this.$http
      .post("rpt/MyOrdersHistory.aspx/GetInitOrderHistoryData", {
        pagingOptions: {
          PageNumber: 1,
          PageSize: this.leadPageSize,
          Start: 0,
          SortBy: "OrderDate",
          SortDescending: true,
          FetchTotalRecordCount: true,
          TotalRecordCount: 0,
        },
      })
      .then(
        (resp) => {
          this.LeadData = resp.body.d.DataSource.ReportData.Items;
          this.isOrderBusy = false;
          this.totalLeadDataCount =
            resp.body.d.DataSource.ReportData.TotalRecordCount;
        },
        (resp) => {}
      );
  },
  methods: {
    leadPageChange() {
      this.isOrderBusy = true;
      this.$http
        .post("rpt/MyOrdersHistory.aspx/GetOrderHisotry", {
          accountId: this.accountId,
          orderName: "",
          orderNumber: "",
          searchKey: this.searchKey,
          pagingOptions: {
            PageNumber: this.LeadDataCurrentPage,
            PageSize: this.leadPageSize,
            Start: 1,
            SortBy: "OrderDate",
            SortDescending: true,
            FetchTotalRecordCount: true,
            TotalRecordCount: 0,
          },
        })
        .then(
          (resp) => {
            this.LeadData = resp.body.d.DataSource.ReportData.Items;
            this.isOrderBusy = false;
            this.totalLeadDataCount =
              resp.body.d.DataSource.ReportData.TotalRecordCount;
            this.AdditionalOutputColumns =
              resp.body.d.DataSource.AdditionalOutputColumns;
          },
          (resp) => {}
        );
    },
    searchChange() {
      if (this.searchKey.length >= 3 || this.searchKey === "") {
        this.leadPageChange();
      }
    },
    tabClick(val) {
      this.tabType = val;
    },
    getAccountName(data) {
      if (this.roleName === "Power User") return data.AccountName;
      else if (this.roleName === "Reseller") return data.UserName;
      else return "";
    },
    showDetail(data) {
      this.$http
        .post("dialogs/OrderDetails.aspx/GetOrder", {
          sessionId: data.item.SessionId,
        })
        .then(
          (resp) => {
            this.isOrderBusy = false;
            this.detail = resp.body.d.DataSource.Order;
            this.detail.DataSourceDesc = data.item.DataSourceDesc;
            this.ServicesListHtmlText =
              resp.body.d.DataSource.ServicesListHtmlText;
            this.$refs.seeOrderDetail.show();
          },
          (resp) => {}
        );
    },
    orderMore(data) {
      this.page.PageNumber = 1;
      this.suppressions = [];
      this.orderMoreData = data.item;
      this.suppressions.push({
        name: data.item.OrderDesc,
        code: data.item.OrderCode,
        id: data.item.OrderId,
      });
      this.$http
        .post("rpt/MyOrdersHistory.aspx/GetOrderMoreByOrder", {
          orderId: this.orderMoreData.OrderId,
        })
        .then(
          (resp) => {
            if (resp.body.d.ResultFlag) {
              this.orderMoreData.AccountId =
                resp.body.d.DataSource.Target.AccountId;
            }
          },
          (resp) => {}
        );
      this.$refs.orderMore.show();
    },
    orderMoreError(resp) {
      this.isOrdering = false;
      notificaton.notice("error", "Please try again, or cantact us", {
        title: "Order More Failed",
        onlyGroup: "connectError",
      });
    },
    orderMoreClick() {
      var order = {
        SuppressionType: 2,
        // OrderSuppressions
        OrderSuppressions: [
          {
            SuppressedOrderId: this.orderMoreData.OrderId,
            SuppressionName: this.orderMoreData.OrderDesc,
            SuppressionValue: this.orderMoreData.OrderCode,
            OriginalOrderId: this.orderMoreData.OrderId,
            SuppressedOrderCode: this.orderMoreData.OrderCode,
            SuppressedOrderDesc: this.orderMoreData.OrderDesc,
          },
        ],
        ListType: this.orderMoreData.ListType,
        AccountId: this.orderMoreData.AccountId,
        // entity Order
      };
      if (this.selected === "Yes") {
        if (this.subType === "date") {
          order.SuppressionType = 1;
          order.SuppressionStartDate = this.orderMoreData.SuppressionStartDate;
          order.SuppressionEndDate = this.orderMoreData.SuppressionEndDate;
        } else {
          let suppressions = [];
          suppressions = this.suppressions.map((item) => {
            return {
              SuppressedOrderId: item.id,
              SuppressionName: item.name,
              SuppressionValue: item.code,
              OriginalOrderId: item.id,
              SuppressedOrderCode: item.code,
              SuppressedOrderDesc: item.name,
            };
          });
          order.OrderSuppressions = suppressions;
        }
      }
      if (order.ListType === 50) {
        // entity.enums.DataSourceType.Occupant
        order.OrderSuppressions = [];
        order.SuppressionType = 0;
      }

      this.submitOrderMore(order);
    },
    submitOrderMore(order) {
      var that = this;
      this.$http
        .post("rpt/MyOrdersHistory.aspx/SubmitForOrderMore", {
          order: order,
        })
        .then(
          (resp) => {
            if (resp.body.d.ResultFlag) {
              this.isOrdering = false;
              window.location.href = this.$store.getters["config/link"](
                "getOrderMoreCountGo"
              );
            } else {
              that.orderMoreError(resp);
            }
          },
          (resp) => {
            that.orderMoreError(resp);
          }
        );
    },
    getSuppression() {
      this.$http
        .post("PlaceOrder.aspx/GetSuppressionList", {
          accountId: this.orderMoreData.AccountId,
          orderName: "",
          orderNumber: "",
          pagingOptions: this.page,
          listtype: this.orderMoreData.ListType,
        })
        .then(
          (resp) => {
            this.itemDatas = resp.body.d.DataSource.Items;
            this.suppressionTotalCount =
              resp.body.d.DataSource.TotalRecordCount;
          },
          (resp) => {}
        );
    },
    addItem(item) {
      this.$set(item, "added", true);
      this.suppressions.push({
        name: item.OrderDesc,
        code: item.OrderCode,
        id: item.OrderId,
      });
    },
    suppressionTypeChange(e) {
      if (e === "Yes" && this.itemDatas.length === 0) {
        this.getSuppression();
      }
    },
    removeItem(code) {
      let index = _.findIndex(this.suppressions, (item) => {
        return item.code === code;
      });
      let itemIndex = _.findIndex(this.itemDatas, (i) => {
        return i.OrderCode === code;
      });
      this.$set(this.itemDatas[itemIndex], "added", false);
      this.suppressions.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  text-align: center;
  font-weight: bold;
  color: black;
}
.content {
  display: flex;
  justify-content: center;
  background: white;
}
.reach {
  width: 90%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}
.left-title {
  text-align: left;
}
.right-title {
  text-align: right;
}

.search-text {
  max-width: 500px;
}
.account-select {
  max-width: 200px;
}
.text-danger {
  color: $color-primary !important;
}
.page-class.page-link {
  color: $color-primary !important;
}
.pageinfo {
  font-size: 1.1rem;
  font-weight: bold;
  text-align: left;
}
.custom-radio {
  display: inline-block !important;
}
</style>
<style>
</style>


// WEBPACK FOOTER //
// src/components/orderHistory/MOrderHistory.vue